import { Box, Button, Flex, Image, Text } from "rebass/styled-components";
import styled from "styled-components";
import Countdown from "react-countdown";
import { useHistory } from "react-router-dom";

import { CountDownRenderer } from "MVVM/Components/CountDownRenderer";
import { IClipPagePromotion } from "../@types";
import theme from "theme/themeThree";
import { analytics } from "MVVM/Analytics";
import { useEffect, useState } from "react";

export const ClipPagePromotion = ({
  promotion,
}: {
  promotion: IClipPagePromotion;
}) => {
  const history = useHistory();
  const [trackedImpression, setTrackedImpression] = useState(false);
  const handleButtonClick = () => {
    if (!promotion.buttonURL) return;
    analytics.track("Promotion - Button Click", {
      type: "clipPagePromotion",
      promotionName: promotion?.name,
    });
    if (promotion?.buttonURL?.includes("http")) {
      window.open(promotion.buttonURL, "_blank");
    } else {
      history.push(promotion.buttonURL);
    }
  };

  useEffect(() => {
    if (!trackedImpression) {
      analytics.track("Promotion - Impression", {
        type: "clipPagePromotion",
        promotionName: promotion?.name,
      });
      setTrackedImpression(true);
    }
  }, [trackedImpression, promotion?.name]);

  return (
    <Box mx={6} mt={6} mb={2}>
      <Container
        backgroundImage={`${process.env.REACT_APP_S3_CLIP_BUCKET}/${promotion.backgroundImage}`}
        style={{ padding: "16px" }}
      >
        <Flex flexDirection="row" style={{ gap: 8 }}>
          <Flex
            style={{ gap: "20px" }}
            flexDirection="column"
            justifyContent="center"
            flexBasis="50%"
          >
            {promotion.image && (
              <Image
                flexShrink={0}
                flexGrow={0}
                src={`${process.env.REACT_APP_S3_CLIP_BUCKET}/${promotion.image}`}
                style={{ zIndex: 2, width: "70%" }}
              />
            )}
            {promotion.showTimer && (
              <Countdown
                date={new Date(promotion.endDate)}
                renderer={(props) => (
                  <CountDownRenderer
                    days={props.days}
                    hours={props.hours}
                    minutes={props.minutes}
                    seconds={props.seconds}
                    color={promotion.buttonColor || "#000000"}
                    variant="text.labelSmall"
                    showEndsIn={true}
                    showIcon={false}
                  />
                )}
              />
            )}
          </Flex>
          <Flex
            alignItems="space-between"
            justifyContent="center"
            flexDirection="column"
            style={{ gap: "20px" }}
            flexBasis="50%"
          >
            <StyledText fontSize={1} fontWeight={500} textAlign="right">
              {promotion.subTextCopy}
            </StyledText>
            {promotion.buttonCTA && (
              <StyledButton
                textColor={promotion.buttonTextColor}
                buttonColor={promotion.buttonColor}
                width="140px"
                style={{
                  padding: "2px",
                  height: "40px",
                  borderRadius: "20px",
                  lineHeight: "1em",
                  width: "140px",
                  zIndex: 0,
                  marginLeft: "auto",
                }}
                onClick={handleButtonClick}
              >
                {promotion.buttonCTA}
              </StyledButton>
            )}
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

const StyledButton = styled(Button)<{
  width: string;
  textColor: string;
  buttonColor: string;
}>`
  background: ${(props) => props.buttonColor};
  color: ${({ textColor }) => textColor || theme.colors.ice};
  cursor: pointer;
  font-size: ${({ theme }) => theme.text.subheader.fontSize};
  width: ${(props) => props.width || "200px"};
  z-index: 2;

  :hover {
    background: ${(props) => props.buttonColor};
    filter: brightness(90%);
  }
`;

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  max-width: 600px;
  z-index: 1;

  @media (max-width: ${({ theme }) => theme.breaks.standard}) {
    display: none;
  }
`;

const Container = styled(Flex)<{ backgroundImage: string }>`
  align-items: center;
  border-radius: 9px;
  gap: 10px;
  justify-content: space-between;
  padding: 20px;
  position: relative;
  width: 100%;

  &::before {
    background-image: url(${(props) => props.backgroundImage});
    background-position: center;
    background-size: cover;
    border-radius: 9px;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.breaks.standard}) {
    justify-content: space-between;
  }
  @media (max-width: 600px) {
    &::before {
      background-position: top left; /* Shift the background image */
    }
  }
`;
